import { render } from "./TheFooter.vue?vue&type=template&id=2ce00da4&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=2ce00da4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce00da4"]])

export default __exports__